import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { ExternalPatientRoleGuard } from "../../shared/authguards/external-patient-role.guard";
import {epakRoleGuard} from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const CROSS_COMMUNICATION_ROUTES: Routes = [
  {
    path: "cross-communication",
    loadComponent: () => import("./cross-communication.component").then(m => m.CrossCommunicationComponent),
    canActivate: [AuthGuard, ExternalPatientRoleGuard],
    data: { title: "pageTitles.crossCommunication" },
    children: [
      {
        path: "",
        loadComponent: () => import("./cross-communication-info/cross-communication-info.component").then(m => m.CrossCommunicationInfoComponent),
        data: { title: "pageTitles.messageToAnotherCenter" },
      },
      {
        path: "institution-list",
        loadComponent: () => import("./institution-list/institution-list.component").then(m => m.InstitutionListComponent),
        canActivate: [epakRoleGuard],
        data: { title: "pageTitles.practitioners" },
      },
      {
        path: "review",
        loadComponent: () => import("./cross-communication-review/cross-communication-review.component").then(m => m.CrossCommunicationReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.messageToAnotherCenterReview" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
